<style lang="scss">

</style>

<template>
  <section class="ui-stats-item">
    <div class="col-12 pb-0">
      <h4 class="font-weight-bold text-center title-divider top-divider">Shows Caller Feedback for the last {{filters.days}} days</h4>
    </div>

    <div v-if="filters.prisonId">
      <div class="pb-0 col-12">
        <div v-if="prisonStats" class="row text-center">
          <p class="col-6 brand-color font-weight-bold mb-0">Average Feedback rating for {{'prison' | term(true)}}: <b>{{prisonStats.average_feedback_rating.toFixed(1)}}</b></p>
          <p class="col-6 brand-color font-weight-bold mb-0">Total Feedback rating for {{'prison' | term(true)}}: <b>{{prisonStats.total_feedback}}</b></p>
        </div>
      </div>

      <div class="col-12">
        <section class="d-flex full-width mt-3 mb-4">
          <div class="ui-spacer"></div>
          <select style="max-width: 300px" class="form-control select-arrow" v-model="activeChart">
            <option value="average">Average Feedback</option>
            <option value="total">Total Feedback</option>
          </select>
        </section>

        <div style="min-height: 350px">
          <section  v-if="!loadingStats && !loadingChart">
            <bar-chart-simple v-if="activeChart === 'average'"
                              :title="'Leaderboard: Average Feedback for ' + filters.days + ' Days'"
                              y-title="Average Feedback number"
                              :x-title="$options.filters.term('prison', true)"
                              max-width="600px" chart-id="chartAverage" :series="chartAverage"></bar-chart-simple>

            <bar-chart-simple v-if="activeChart === 'total'"
                              :title="'Leaderboard: Total feedback for ' + filters.days + ' Days'"
                              y-title="Total Feedback number"
                              :x-title="$options.filters.term('prison', true)"
                              max-width="600px" chart-id="chartTotal" :series="chartTotal"></bar-chart-simple>
          </section>

          <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
            <p class="full-width d-flex justify-content-center">Getting Stats...</p>
            <b-spinner variant="primary"></b-spinner>
          </section>
        </div>
      </div>
    </div>

    <div class="col-12" v-else>
      <p>Please Select a prison to see stats</p>
    </div>

  </section>
</template>

<script>
  import HelperService from '../../../services/HelperService';
  import FeedbackService from '../../../services/FeedbackService';
  import BarChartSimple from '@/components/charts/BarChartSimple';

  export default {
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    components: {
      BarChartSimple,
    },
    watch: {
      filters: {
        handler() {
          this.getFeedbackLeaderboard();
          this.getPrisonFeedbackStats();
        },
        deep: true,
      },
      activeChart() {
        this.loadingChart = true;

        setTimeout(() => {
          this.loadingChart = false;
        }, 500);
      }
    },
    data() {
      return {
        helperService: new HelperService(),
        loadingStats: true,
        loadingStatsPrison: true,
        activeChart: 'average',
        stats: [],
        prisonStats: null,
        loadingChart: false,
        chartAverage: null,
        chartTotal: null,
      };
    },
    mounted() {
      this.getFeedbackLeaderboard();
      this.getPrisonFeedbackStats();
    },
    methods: {
      getPrisonFeedbackStats() {
        this.loadingStatsPrison = true;

        if (this.filters.prisonId) {
          return FeedbackService.getFeedbackStatsAverage(this.filters).then((res) => {
            this.prisonStats = res.data;
          }).catch((err) => {
            console.log('could not get feedback stats', err);
            this.$toasted.error('Error getting feedback stats, please refresh and try again');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStatsPrison = false;
            }, 1000);
          });
        }

        return null;
      },
      getFeedbackLeaderboard() {
        this.loadingStats = true;

        if (this.filters.prisonId) {
          return FeedbackService.getFeedbackLeaderboard(this.filters).then((res) => {
            let leaderBoardStats = res.data.prisons;
            // Order
            if(leaderBoardStats && leaderBoardStats.length > 0) {
              leaderBoardStats = leaderBoardStats.sort((p1, p2) => p2.average_feedback_rating - p1.average_feedback_rating);
              if(leaderBoardStats.length > 5) {
                // Slice
                leaderBoardStats = leaderBoardStats.slice(0, 5);
                // Check the prison is included
                let prisonIncluded = false;
                leaderBoardStats.forEach((stat) => {
                  if(stat.prison_id === this.filters.prisonId) {
                    prisonIncluded = true;
                  }
                });
                // Check if prison is not included
                if(!prisonIncluded) {
                  // Find prison and add it to array
                  res.data.prisons.forEach((stat) => {
                    if(stat.prison_id === this.filters.prisonId) {
                      leaderBoardStats.push(stat);
                    }
                  });
                }
              }
            }
            this.stats = leaderBoardStats;
            this.chartAverage = this.createChartJsChart(this.stats.average_feedback_rating, res.data.prisons, 'average_feedback_rating');
            this.chartTotal = this.createChartJsChart(this.stats.total_feedback, res.data.prisons, 'total_feedback');
          }).catch((err) => {
            console.log('could not get feedback stats', err);
            this.$toasted.error('Error getting feedback stats, please refresh and try again');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }

        return null;
      },
      createChartJsChart(data, prisons, propName) {
        let chart = {
          data: [],
          labels: [],
        };

        prisons.forEach((prison) => {
          chart.data.push(prison[propName].toFixed(1));
          chart.labels.push(prison.prison_name);
        });

        return chart;
      },
    },
  };
</script>
